
import Member from "./member.vue";
import { Component, Vue } from 'vue-facing-decorator'

@Component({
  components: { Member },
})
export default class extends Vue {
  activeName = "1"
  loading = true
  source = ''
  created() {
    this.getData();
  }

  async getData() {
    this.loading = true;
    let { error, data, message } = await this.$getDownload(
      "/manager/open-platform/test-qrcode",
      {
      },
      {
        auto: false,
        method: 'GET'
      }
    );
    this.loading = false;
    if (error) return this.$error(message || "体验码加载失败");
    this.source = data;
  }
}
